import React, { createContext, useState, useEffect, useContext } from 'react';
import AnonymousSignupModal from '../components/auth/AnonymousSignupModal';

const SignupModalContext = createContext(null);

export const SignupModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [featureName, setFeatureName] = useState('');
  
  // Listen for signup events from API interceptor
  useEffect(() => {
    const handleSignupNeeded = (event) => {
      const { feature } = event.detail;
      setFeatureName(feature);
      setIsOpen(true);
    };
    
    window.addEventListener('anonymousUserNeedsSignup', handleSignupNeeded);
    return () => window.removeEventListener('anonymousUserNeedsSignup', handleSignupNeeded);
  }, []);
  
  const showSignupModal = (feature) => {
    setFeatureName(feature);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    // Dispatch event to notify that signup modal was closed (either cancelled or completed)
    window.dispatchEvent(new CustomEvent('signupModalClosed'));
  };
  
  return (
    <SignupModalContext.Provider value={{ showSignupModal, closeModal }}>
      {children}
      <AnonymousSignupModal 
        isOpen={isOpen} 
        onClose={closeModal}
        featureName={featureName}
      />
    </SignupModalContext.Provider>
  );
};

export const useSignupModal = () => {
  const context = useContext(SignupModalContext);
  if (!context) {
    throw new Error('useSignupModal must be used within SignupModalProvider');
  }
  return context;
};

export default SignupModalContext;

